module.exports = __webpack_public_path__ + "static/media/space-station-moon.706326b6.svg";